import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PlaceIcon from '@mui/icons-material/Place';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { setSearchInput, setSelectedEvent } from '../../../../store/Actions';

export const SearchOption = (props) => {
    const userCategories = useSelector(state => state.viewingUserCategories);
    const dispatch = useDispatch();

    const handleClick = () => {
        if (props.event) {
            dispatch(setSelectedEvent(props.event));
            dispatch(setSearchInput(props.event.title));
        }
        props.setPopupOpen(false);
    };

    if (props.event) {
        const tint = userCategories[props.event.categoryId]?.pinColor || '#525252';
        // Compose a soft gradient from the category color so the tile feels alive
        const tintGradient = `linear-gradient(135deg, ${tint} 0%, ${tint} 60%, rgba(0,0,0,0.18) 100%)`;
        return (
            <button type="button" className="popup-option" onClick={handleClick}>
                <span
                    className="popup-option__icon popup-option__icon--tinted"
                    style={{ background: tintGradient, boxShadow: `inset 0 1px 0 rgba(255,255,255,0.30), 0 2px 4px ${tint}55` }}
                >
                    <span style={{ fontSize: 17, lineHeight: 1 }}>{props.event.emoji}</span>
                </span>
                <span className="popup-option__body">
                    <span className="popup-option__title">{props.event.title}</span>
                    {props.event.location?.description && (
                        <span className="popup-option__subtitle">
                            <PlaceIcon/>
                            {props.event.location.description}
                        </span>
                    )}
                </span>
                <ChevronRightIcon className="popup-option__chevron" />
            </button>
        );
    }

    return null;
};
